module.exports = {
          srcSet: __webpack_public_path__ + "3675d3af32a1f3c5c321e16da0f4dec1-60.png"+" 60w",
          images:[ {path: __webpack_public_path__ + "3675d3af32a1f3c5c321e16da0f4dec1-60.png",width: 60,height: 60}],
          src: __webpack_public_path__ + "3675d3af32a1f3c5c321e16da0f4dec1-60.png",
          toString:function(){return __webpack_public_path__ + "3675d3af32a1f3c5c321e16da0f4dec1-60.png"},
          
          width: 60,
          height: 60
        }